"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Expressions_1 = require("./Expressions");

var SpecialOperator = function SpecialOperator(args, applyAsync, applySync) {
  _classCallCheck(this, SpecialOperator);

  this.args = args;
  this.applyAsync = applyAsync;
  this.applySync = applySync;
  this.expressionType = Expressions_1.ExpressionType.SpecialOperator;
};

exports.SpecialOperator = SpecialOperator;